import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import { customStyles } from '../../../../HelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getCityListByState, getStateListByCountry } from '../../../../Redux/action/MasterAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';

const EditSeaport = ({ port_id, show, handleClose, token, user_id, refresh, loadingCountry, destinationCountryData, loadingMasterSeaportDetail, MasterSeaportDetail }) => {
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [countryOptions, setCountryOptions] = useState([]);

    let initialValues = {
        name: "",
        code: "",
        country_id: "",
        country_name: "",
        state_id: "",
        state_name: "",
        city_id: "",
        city_name: "",
        iata: "",
        // latitude: "",
        // longitude: "",
    };

    useEffect(() => {
        if (destinationCountryData) {
            let arr = [];
            destinationCountryData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCountryOptions(arr);
        }
    }, [destinationCountryData]);


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if (port_id) {
                    values.id = port_id
                } else {
                    toast.error("ID is required.");
                    return;
                }
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/master/airport/edit`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (token && user_id && formik.values.country_id) {
            dispatch(getStateListByCountry(token, user_id, formik.values.country_id,))
        }
    }, [formik.values.country_id]);

    useEffect(() => {
        if (token && user_id && formik.values.state_id) {
            dispatch(getCityListByState(token, user_id, formik.values.state_id,))
        }
    }, [formik.values.state_id]);


    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);

    const {
        loadingMasterStateByCountryList,
        MasterStateByCountryList,
        MasterStateByCountryListError,

        loadingMasterCityByStateList,
        MasterCityByStateList,
        MasterCityByStateListError
    } = useSelector(state => state.MasterReducer);


    useEffect(() => {
        if (MasterStateByCountryList) {
            let arr = [];
            MasterStateByCountryList.map(val => { arr.push({ value: val.id, label: val.name }) });
            setStateOptions(arr);
        }
    }, [loadingMasterStateByCountryList, MasterStateByCountryList])

    useEffect(() => {
        if (MasterCityByStateList) {
            let arr = [];
            MasterCityByStateList.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCityOptions(arr);
        }
    }, [loadingMasterCityByStateList, MasterCityByStateList]);


    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        if (loadingMasterSeaportDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (MasterSeaportDetail) {
            // console.log(MasterSeaportDetail);
            formik.setFieldValue("name", MasterSeaportDetail?.name);
            formik.setFieldValue("code", MasterSeaportDetail?.code);
            formik.setFieldValue("country_id", MasterSeaportDetail?.country_id);
            formik.setFieldValue("country_name", MasterSeaportDetail?.country_name);
            formik.setFieldValue("state_id", MasterSeaportDetail?.state_id);
            formik.setFieldValue("state_name", MasterSeaportDetail?.state_name);
            formik.setFieldValue("city_id", MasterSeaportDetail?.city_id);
            formik.setFieldValue("city_name", MasterSeaportDetail?.city_name);
            formik.setFieldValue("iata", MasterSeaportDetail?.iata);
        }
    }, [loadingMasterSeaportDetail, MasterSeaportDetail]);

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Seaport</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <InputTextJSX
                                        labelText={"Seaport Name"}
                                        nameValue={"name"}
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />
                                    <InputTextJSX
                                        labelText={"Code"}
                                        nameValue={"code"}
                                        value={formik.values.code}
                                        onChange={formik.handleChange}
                                    />


                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Country
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={countryOptions}
                                                    styles={customStyles}
                                                    name="country_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('country_name', "");
                                                        formik.setFieldValue('country_id', option.value);
                                                        formik.setFieldValue('country_name', option.label);
                                                        // handleGetStates(option.value);
                                                    }}
                                                    value={countryOptions.find(option => option.value == formik.values.country_id) || null}
                                                    isLoading={loadingCountry}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Country Name
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                {formik.values.country_name}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                State
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={stateOptions}
                                                    styles={customStyles}
                                                    name="state_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('state_name', "");
                                                        formik.setFieldValue('state_id', option.value);
                                                        formik.setFieldValue('state_name', option.label);
                                                    }}
                                                    value={stateOptions.find(option => option.value == formik.values.state_id) || null}
                                                    isLoading={loadingMasterStateByCountryList}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                State Name
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                {formik.values.state_name}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                City
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={cityOptions}
                                                    styles={customStyles}
                                                    name="city_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('city_name', "");
                                                        formik.setFieldValue('city_id', option.value);
                                                        formik.setFieldValue('city_name', option.label);
                                                    }}
                                                    value={cityOptions.find(option => option.value == formik.values.city_id) || null}
                                                    isLoading={loadingMasterCityByStateList}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                City Name
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                {formik.values.city_name}
                                            </div>
                                        </div>
                                    </div>

                                    <InputTextJSX
                                        labelText={"IATA"}
                                        nameValue={"iata"}
                                        value={formik.values.iata}
                                        onChange={formik.handleChange}
                                    />

                                    <div className="row d-flex justify-content-end mt-2">
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                {
                                                    disableSubmit ?
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Saving...
                                                        </>
                                                        :
                                                        "Update"
                                                }
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </form>
                        </Offcanvas.Body>
                    </Offcanvas>
            }

        </>
    )
}

export default EditSeaport